import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3000,
        style: {
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '14px',
          borderRadius: '12px',
          padding: '12px 20px',
        },
        success: { style: { background: '#ECFDF5', color: '#065F46', border: '1px solid #A7F3D0' } },
        error:   { style: { background: '#FEF2F2', color: '#991B1B', border: '1px solid #FECACA' } },
      }}
    />
  </>
);
